import Vue from 'vue'

function isEmpty(value) {
  if (value === null || value === '' || value === undefined) {
    return true;
  } else if (Array.isArray(value)) {
    return value.length === 0;
  } else if (typeof value === 'object') {
    return Object.keys(value).length === 0;
  }
  return false;
}

export const queryStr = (json) => {
  let queryStr = '?'
  for (let t in json) {
    !isEmpty(json[t]) && (queryStr += t + '=' + json[t] + '&')
  }
  return queryStr.slice(0, queryStr.length - 1)
}

const jsonUtil = {
  // 转换成字符串
  toStr (json) {
    let str = ''
    try {
      str = JSON.stringify(json)
    } catch (e) {
      console.error(e)
    }
    return str
  },
  
  // 返回url请求字段
  queryStr
}

Vue.prototype.$json = jsonUtil